import { AutogenLayoutPurgeControlList } from "./autogen/AutogenLayoutPurgeControlList";

export class PurgeControlList extends AutogenLayoutPurgeControlList {

    override async onLoad() {
        this.switchHeaderIsEnabled.allowIndeterminate = true;
        this.switchHeaderIsEnabled.checked = undefined;
        this.switchHeaderIsEnabledSecondaries.allowIndeterminate = true;
        this.switchHeaderIsEnabledSecondaries.checked = undefined;
    }
}
